import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

import Menu from '../../components/Menu';
import Container from '../../containers/Container';
import Grid from '../../components/Grid';
import Button from '../../components/Button';
import { ReactComponent as LogoSvg } from '../../res/logo_blanc.svg';
import styles from './styles';

import { ReactComponent as HexaSvg1 } from '../../res/hexa1.svg';
import { ReactComponent as HexaSvg2 } from '../../res/hexa2.svg';

const BASE_URL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? '' : process.env.PUBLIC_URL;

class FichesFirst extends React.Component {
  onClickButton(id) {
    const element = document.getElementById(id);
    if (element && element.offsetTop) {
      window.scroll({ top: element.offsetTop, behavior: 'smooth' });
    }
  }

  render() {
    const { classes, data } = this.props;
    const { first: block } = data.fiches;
    return (
      <Container id="fiches-first" className={classes.container} zIndex={6}>
        <HexaSvg1 className={classes.hexaSvg1} />
        <HexaSvg2 className={classes.hexaSvg2} />
        <Menu data={data} route="fiches" />
        <Link className={classes.logoContainer} to={`${BASE_URL}/`}>
          <LogoSvg className={classes.logo} />
        </Link>
        <Typography variant="h2" className={classes.title}>
          {parse(block.title)}
        </Typography>
        <div className={classes.buttonBackContainer}>
          <Button color="grey2" to={`${BASE_URL}/`} component={Link} onClick={() => window.scroll({ top: 0 })}>
            {block['button-back']}
          </Button>
        </div>
        <Container maxWidth="lg">
          <Grid justify="space-between" spacing={4} className={classes.hexaGrid}>
            <div className={`${classes.hexa} ${classes.hexa1}`} key="1">
              <Typography className={`${classes.hexaNum} ${classes.hexaNum1}`}>{parse(block.hexa1.num)}</Typography>
              <Typography className={classes.hexaTitle} variant="subtitle1">
                {parse(block.hexa1.title)}
              </Typography>
              <Button
                className={classes.hexaButton}
                color="pink"
                onClick={() => this.onClickButton('fiches-actions-types')}
              >
                {parse(block['button-label'])}
              </Button>
            </div>
            <div className={`${classes.hexa} ${classes.hexa2}`} key="2">
              <Typography className={`${classes.hexaNum} ${classes.hexaNum2}`}>{parse(block.hexa2.num)}</Typography>
              <Typography className={classes.hexaTitle} variant="subtitle1">
                {parse(block.hexa2.title)}
              </Typography>
              <Button
                className={classes.hexaButton}
                color="yellow"
                onClick={() => this.onClickButton('fiches-actions-transversales')}
              >
                {parse(block['button-label'])}
              </Button>
            </div>
            <div className={`${classes.hexa} ${classes.hexa3}`} key="3">
              <Typography className={`${classes.hexaNum} ${classes.hexaNum3}`}>{parse(block.hexa3.num)}</Typography>
              <Typography className={classes.hexaTitle} variant="subtitle1">
                {parse(block.hexa3.title)}
              </Typography>
              <Button
                className={classes.hexaButton}
                color="blueLight"
                onClick={() => this.onClickButton('fiches-retour-experience')}
              >
                {parse(block['button-label'])}
              </Button>
            </div>
          </Grid>
        </Container>
      </Container>
    );
  }
}

FichesFirst.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FichesFirst);
